<template>
  <div id="main-content" class="grid grid-cols-3 p-3 text-gray-900">
    <button
      class="absolute right-1/3 text-gray-400 rounded focus:outline-none hover:text-yellow-400"
      @click="closeStatistics"
      v-if="statisticsVisible"
    >
      <span class="font-semibold">Hide Analysis</span>
      <ChevronDoubleRightIcon class="h-5 w-5 inline" />
    </button>
    <button
      class="absolute right-0 mr-12 text-gray-200 rounded focus:outline-none"
      @click="openStatistics"
      v-if="!statisticsVisible"
    >
      <span class="font-semibold">View Analysis</span>
      <ChevronDoubleLeftIcon class="h-5 w-5 inline" />
    </button>
    <div id="main-content" class="col-span-3 mt-9">
      <div class="lg:text-2xl md:text-xl sm:text-base p-2 font-semibold bg-gray-300 rounded">
        {{ affiliation.name }}
      </div>
      <div class="p-2 md:text-base sm:text-sm text-gray-600">
        <div v-if="affiliation.pubCount">
          <span class="font-semibold">Publication Count:</span> {{ affiliation.pubCount }}
        </div>
      </div>
      <div class="p-2 md:text-base sm:text-sm text-gray-600">
        <div v-if="affiliation.officialPageUrl">
          <span class="font-semibold">Official Page:</span> {{ affiliation.officialPageUrl }}
        </div>
      </div>
      <div class="p-2 md:text-base sm:text-sm text-gray-600">
        <div v-if="affiliation.wikiPageUrl">
          <span class="font-semibold">Wikipedia URL:</span> {{ affiliation.wikiPageUrl }}
        </div>
      </div>
    </div>

    <div v-if="statisticsVisible" class="col-span-1 mt-6 p-3">
      <div class="border border-gray-300 rounded h-1/3">Keywords</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from '@heroicons/vue/solid';
import { Affiliation } from '@/models/Details';

export default defineComponent({
  name: 'AffiliationPage',
  components: {
    ChevronDoubleLeftIcon,
    ChevronDoubleRightIcon,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    // constants reactive to consider a possible change of the displayed publication
    const statisticsVisible = ref(false);
    const affiliation = ref(Object as unknown as Affiliation);

    // TODO: fetch author using existing axios
    const fetchAffiliation = (id?: number) => {
      if (id || props.id) {
        let reqId: number;
        if (id) reqId = id;
        else if (props.id) reqId = props.id;
        else {
          emit('fetchFailed');
          return;
        }
        emit('loading');
        fetch('https://api.ambalytics.cloud/entities', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Content-Length': '142' },
          body: `{"query":"query getAffiliation($id: ID!) { affiliation(id: $id) {id, name, normalizedName, pubCount, latitude, longitude, officialPageUrl, wikiPageUrl }}" ,"variables":{"id":"${reqId}"}}`,
        })
          .then((res) => res.json())
          .then((res) => {
            if (!res.data.affiliation) return; //TODO: reaction to author == null
            affiliation.value = { ...res.data.affiliation };
            emit('stopLoading');
          })
          .catch((reason) => {
            emit('fetchFailed');
            console.error('fetch failed because ' + reason);
          });
      } else {
        emit('fetchFailed');
      }
    };

    onMounted(() => {
      fetchAffiliation();
    });

    const closeStatistics = () => {
      statisticsVisible.value = false;
      document.getElementById('main-content')?.classList.add('col-span-3');
      document.getElementById('main-content')?.classList.remove('col-span-2');
    };
    const openStatistics = () => {
      // ToDo: enable as soon as statistics has content + add hover:text-yellow-400 to main-content
      // statisticsVisible.value = true;
      // document.getElementById('main-content')?.classList.remove('col-span-3');
      // document.getElementById('main-content')?.classList.add('col-span-2');
    };

    return {
      statisticsVisible,
      closeStatistics,
      openStatistics,
      affiliation,
    };
  },
});
</script>
